import { Settings } from "../../../Settings";
import Path from "../Path";
import PathPlanJumpLeft from "../plan/PathPlanJumpLeft";
import PathPlanJumpRight from "../plan/PathPlanJumpRight";
import PathTemplatePattern from "./PathTemplatePattern";


// PATTERN VALUES:
// S start
// P path
// E end
// X closed
// O open
// 8 open or path
// . ignore

export default class PatternJump0Side3 extends PathTemplatePattern {
    constructor() {
        super([
            '.OO.',     // ignore open   open   ignore
            'S88E',     // start  o|p    o|p    end
            'X88.'     //  closed o|p    o|p    closed
        ],
        true);  // true to flip left/right
    }

    /**
     * Returns the minimum number of path steps required by this pattern to be applied.
     * @override
     * @returns {number}
     */    
    getMinRequiredPathSteps() {
        return 3;
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlan(path, pathIndex) {
        const start = path.tiles[pathIndex];

        const targetCol = start.getTileCol() + 3; // end tile is 3 columns to the right of start
        const targetRow = start.getTileRow();     // end tile is on same row as start
        const endIndex = this.findTilePathIndex(path, pathIndex + 3, targetCol, targetRow);  // +3: we know the end is at least 3 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpRight(start, end, steps, Settings.tile.threeQuarterSize);
    }

    /**
     * @override
     * @param {Path} path
     * @param {number} pathIndex The path index.
     * @returns {PathPlan}
     */
    getPathPlanFlipped(path, pathIndex) {
        const start = path.tiles[pathIndex];
        
        const targetCol = start.getTileCol() - 3; // end tile is 3 columns to the left of start
        const targetRow = start.getTileRow();     // end tile is on same row as start
        const endIndex = this.findTilePathIndex(path, pathIndex + 3, targetCol, targetRow);  // +4: we know the end is at least 3 steps away in the path.
        if (endIndex < 0) {
            return null;
        }

        const end = path.tiles[endIndex];
        const steps = endIndex - pathIndex;

        return new PathPlanJumpLeft(start, end, steps, Settings.tile.threeQuarterSize);
    }

    /**
     * @override
     * @returns {string}
     */
    toString() {
        return 'PatternJump0Side3';
    }
}